import { addDesktopListener } from '@/utils/breakpoint';

export const caseHighlightsCollapsible = {
  mounted(el) {
    addDesktopListener(handleState);

    function handleState(isDesktop) {
      el.removeEventListener('click', preventStateChange);

      if (isDesktop) {
        el.open = true;
        el.addEventListener('click', preventStateChange);
      } else {
        el.open = false;
      }
    }

    function preventStateChange(e) {
      e.preventDefault();
    }
  },
};
